// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.show {
  display: hidden;
}

.mediaStop {
  height: 140px;
  width: 251px;
  margin: 20px 0px;
}

.setting-accordian .accordion {
  border-bottom: none !important;
  margin-bottom: 0px !important;
}

.settings-section {
  margin: 0 16.66%;
}
.settings-section .settings-form-group h4 {
  font: 2.4rem "Omnes-ATT-W02";
}
.settings-section .settings-form-group .row {
  margin-left: -5px;
}
.settings-section .accheader {
  font-family: "Omnes-ATT-W02";
}
.settings-section .supportArticle ul {
  list-style-type: disc;
}
.settings-section .supportArticle li {
  list-style-type: disc;
}
.settings-section .supportArticle .padding {
  padding-left: 38px;
}
@media (max-width: 1024px) {
  .settings-section {
    margin: 0 15px;
  }
  .settings-section .btn-cancel {
    margin: 20px 0;
    text-align: center;
    width: 100%;
  }
  .settings-section .btn {
    margin: 0;
    text-align: center;
    width: 100%;
  }
  .settings-section .grid-table {
    margin-left: -15px;
    margin-right: -15px;
  }
}
.settings-section .row .col-sm-8, .settings-section .row .col-md-8 {
  padding: 5px;
}
.settings-section .row.extDevNwt {
  margin-bottom: 10px;
}
.settings-section .check {
  margin-bottom: 0;
}
.settings-section .settings-form-group {
  margin-top: 30px;
  border-top: 1px solid #d2d2d2;
  padding: 30px 0 0;
}
@media (max-width: 1024px) {
  .settings-section .settings-form-group .newDevNwt .tooltip-container .helper-text, .settings-section .settings-form-group .extDevNwt .tooltip-container .helper-text {
    top: 54px !important;
  }
}
.settings-section .settings-form-group h3 {
  font-family: "Omnes-ATT-W02";
}
.settings-section .settings-form-group:first-of-type {
  margin-top: 0px;
}
.settings-section .buttons-section {
  margin-top: 30px;
  border-top: 1px solid #d2d2d2;
  padding: 30px 0;
}
@media (max-width: 1024px) {
  .settings-section .buttons-section .btn {
    text-align: center;
    width: 100%;
  }
}
.settings-section .radio {
  display: block;
  margin-bottom: 20px;
}
.settings-section .radio:last-of-type {
  margin-bottom: 30px;
}
.settings-section .checkbox,
.settings-section .radio {
  display: block;
  margin-bottom: 20px;
}
.settings-section .btn-switch-label {
  float: right;
  padding-bottom: 12px;
}
.settings-section .btn-switch-label .label {
  margin-left: 8px !important;
}
.settings-section .walled-garden {
  padding-bottom: 20px;
}
.settings-section tr th:first-child {
  width: 20%;
}
@media (max-width: 1024px) {
  .settings-section {
    margin: 0 15px;
  }
  .settings-section .accordion {
    margin-bottom: 30px;
  }
}
.settings-section .title-section h2 {
  margin-bottom: 30px;
}
.settings-section .title-section:last-child {
  margin-bottom: 30px;
}
.settings-section .title-section.have-accordion {
  padding: 0;
}
.settings-section .title-section.have-accordion:last-child {
  margin-bottom: 0px;
}
.settings-section .title-section p.dropDownLabel {
  font-size: 12px;
  margin: 0px;
}
.settings-section .title-section .dropdown-list span {
  width: 45%;
}
@media (max-width: 1024px) {
  .settings-section .title-section .dropdown-list span {
    width: 100%;
  }
}
.settings-section .title-section .select-list {
  width: 45%;
}
@media (max-width: 1024px) {
  .settings-section .title-section .select-list {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/signup/settings/settings.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAlJA;EACI,eAAA;AAoJJ;;AAjJA;EACI,aAAA;EACA,YAAA;EACA,gBAAA;AAoJJ;;AAlJA;EACI,8BAAA;EACA,6BAAA;AAqJJ;;AAlJA;EAYE,gBAAA;AA0IF;AAlJI;EACA,4BAAA;AAoJJ;AAjJI;EACA,iBAAA;AAmJJ;AA/IE;EAEE,4BAAA;AAgJJ;AA7II;EACE,qBAAA;AA+IN;AA7II;EACE,qBAAA;AA+IN;AA7II;EACE,kBAAA;AA+IN;AF/JI;EETJ;IA8BI,cAAA;EA8IF;EA5IE;IACE,cAAA;IACA,kBAAA;IACA,WAAA;EA8IJ;EA3IE;IACE,SAAA;IACA,kBAAA;IACA,WAAA;EA6IJ;EA1IE;IACE,kBAAA;IACA,mBAAA;EA4IJ;AACF;AAzII;EACA,YAAA;AA2IJ;AAzII;EACI,mBAAA;AA2IR;AAvII;EACI,gBAAA;AAyIR;AAvII;EACI,gBAAA;EACA,6BAAA;EACA,iBAAA;AAyIR;AFhMI;EE2DQ;IACQ,oBAAA;EAwIlB;AACF;AApIQ;EACI,4BAAA;AAsIZ;AAnIQ;EACI,eAAA;AAqIZ;AAjII;EACI,gBAAA;EACA,6BAAA;EACA,eAAA;AAmIR;AFhNI;EE8EI;IAEQ,kBAAA;IACA,WAAA;EAoId;AACF;AAjII;EACI,cAAA;EACA,mBAAA;AAmIR;AAlIQ;EACI,mBAAA;AAoIZ;AAjII;;EAEI,cAAA;EACA,mBAAA;AAmIR;AAjII;EACI,YAAA;EACA,oBAAA;AAmIR;AAlIQ;EACI,2BAAA;AAoIZ;AAhII;EACI,oBAAA;AAkIR;AA9HY;EACI,UAAA;AAgIhB;AF/OI;EETJ;IA6HQ,cAAA;EA+HN;EA7HM;IACI,mBAAA;EA+HV;AACF;AA3HQ;EACI,mBAAA;AA6HZ;AA3HQ;EACI,mBAAA;AA6HZ;AA3HQ;EACI,UAAA;AA6HZ;AA5HY;EACI,kBAAA;AA8HhB;AA3HQ;EACI,eAAA;EACA,WAAA;AA6HZ;AA1HY;EACI,UAAA;AA4HhB;AF1QI;EEiJY;IACI,WAAA;EA4HlB;AACF;AAzHQ;EAII,UAAA;AAwHZ;AFlRI;EEsJI;IAEQ,WAAA;EA8Hd;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n.show {\n    display: hidden;\n}\n\n.mediaStop{\n    height:140px;\n    width:251px;\n    margin: 20px 0px;\n    }\n.setting-accordian .accordion {\n    border-bottom: none !important;\n    margin-bottom: 0px !important;\n    }\n\n.settings-section {\n\n  .settings-form-group{\n\n    h4 {\n    font: 2.4rem 'Omnes-ATT-W02';\n    }\n    \n    .row{\n    margin-left: -5px;\n    }\n    }\n  margin: 0 16.66%;\n  .accheader{\n    // color : #191919 !important;\n    font-family: 'Omnes-ATT-W02';\n  }\n  .supportArticle{\n    ul{\n      list-style-type: disc;\n    }\n    li{\n      list-style-type: disc;\n    }\n    .padding{\n      padding-left:38px;\n    }\n  }\n  \n  @include respond-to (small) {\n    margin: 0 15px;\n\n    .btn-cancel {\n      margin: 20px 0;\n      text-align: center;\n      width: 100%;\n\n    }\n    .btn {\n      margin: 0;\n      text-align: center;\n      width: 100%;\n\n    }\n    .grid-table {\n      margin-left: -15px;\n      margin-right: -15px;\n    }\n  }\n  .row {\n    .col-sm-8,.col-md-8 {\n    padding: 5px;\n    }\n    &.extDevNwt {\n        margin-bottom: 10px;\n    }\n    }\n    //margin: 0 27%;\n    .check {\n        margin-bottom: 0;\n    }\n    .settings-form-group {\n        margin-top: 30px;\n        border-top: 1px solid color(default, dark);\n        padding: 30px 0 0;\n        @include respond-to (small) {\n        .newDevNwt,.extDevNwt{\n        .tooltip-container {\n            .helper-text {\n                    top:54px !important;\n            }\n        }\n    }\n}\n        h3 {\n            font-family: 'Omnes-ATT-W02';\n        }\n        \n        &:first-of-type {\n            margin-top: 0px;\n        }\n    }\n\n    .buttons-section {\n        margin-top: 30px;\n        border-top: 1px solid color(default, dark);\n        padding: 30px 0;\n        .btn {\n            @include respond-to(small) {\n                text-align: center;\n                width: 100%;\n            }\n        }\n    }\n    .radio {\n        display: block;\n        margin-bottom: 20px;\n        &:last-of-type {\n            margin-bottom: 30px;\n        }\n    }\n    .checkbox,\n    .radio {\n        display: block;\n        margin-bottom: 20px;\n    }\n    .btn-switch-label {\n        float: right;\n        padding-bottom: 12px;\n        .label{\n            margin-left: 8px !important;\n          }\n    }\n\n    .walled-garden {\n        padding-bottom: 20px;\n    }\n    tr {\n        th {\n            &:first-child {\n                width: 20%;\n            }\n        }\n    }\n    @include respond-to(small) {\n        margin: 0 15px;\n\n        .accordion {\n            margin-bottom: 30px;\n        }\n    }\n    .title-section {\n        //border-bottom: 1px solid color(default, dark);\n        h2 {\n            margin-bottom: 30px;\n        }\n        &:last-child {\n            margin-bottom: 30px;   \n        }\n        &.have-accordion {\n            padding: 0;\n            &:last-child {\n                margin-bottom: 0px;   \n            }\n        }\n        p.dropDownLabel {\n            font-size: 12px;\n            margin: 0px;\n        }\n        .dropdown-list {\n            span {\n                width: 45%;\n            }\n            @include respond-to(small) {\n                span {\n                    width: 100%;\n                }\n            }\n        }\n        .select-list {\n            @include respond-to(small) {\n                width: 100%;\n            }\n            width: 45%;\n        }\n    }\n//   .acc-content{\n//     padding-bottom: 20px;\n//   }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
